<template>
  <div class="add-prdtoption">
    <div
      class="modal-pagecnt"
      :class="{ open_modal: openAddProductOptionModal }"
    >
      <header class="modalpage-header">
        <span
          class="icon-Btn go-back"
          @click="goBack()"
        >
          <ArrowLeftBackIcon />
        </span>
        <h1>Back</h1>
      </header>

      <!-- <div class="nodata-texbox" v-if="!isProductListLength">
        आपने अभी तक कोई नहीं प्रोडक्ट को ऐड नहीं किया है। सेल को और बढ़ाने के लिए
        प्रोडक्ट को ऐड करे।
      </div> -->

      <div class="modal-midcnt">
        <div class="prdt-type">
          <router-link class="product-tab" tag="div" :to="{ path: '/product-search?&shopid=' + $route.query.shopid  }" v-if="$route.query.shopid">
            <div class="prdt-icon">
              <ProductSearchIcon />
            </div>
            <div class="prdt-info">
              <h2>प्रोडक्ट सर्च करे</h2>
              <p>प्रोडक्ट का नाम सर्च करें और सर्च रिजल्ट्स मैं देखके अपना प्रोडक्ट कैटेलॉग मैं ऐड करें।</p>
              <div class="btn-block">
                <span class="button">सर्च करे </span>
              </div>
            </div>
          </router-link>
           <router-link class="product-tab" tag="div" to="/product-search" v-else>
            <div class="prdt-icon">
              <ProductSearchIcon />
            </div>
            <div class="prdt-info">
              <h2>प्रोडक्ट सर्च करे</h2>
              <p>प्रोडक्ट का नाम सर्च करें और सर्च रिजल्ट्स मैं देखके अपना प्रोडक्ट कैटेलॉग मैं ऐड करें।</p>
              <div class="btn-block">
                <span class="button">सर्च करे </span>
              </div>
            </div>
          </router-link>

          <router-link class="product-tab" tag="div" :to="{ path: '/product-bar-scan?&shopid=' + $route.query.shopid  }" v-if="$route.query.shopid">
            <div class="prdt-icon">
              <ProductBarCodeIcon />
            </div>
            <div class="prdt-info">
              <h2>बारकोड स्कैन करे</h2>
              <p>आपके पास मौजूदा प्रोडक्ट का बार कोड स्कैन करें। फिर स्कैन्ड प्रोडक्ट्स की लिस्ट से प्रोडक्ट को कैटेलॉग मैं ऐड करें।</p>
              <div class="btn-block">
                <span class="button">स्कैन करे </span>
              </div>
            </div>
          </router-link>
          <router-link class="product-tab" tag="div" to="/product-bar-scan" v-else>
            <div class="prdt-icon">
              <ProductBarCodeIcon />
            </div>
            <div class="prdt-info">
              <h2>बारकोड स्कैन करे</h2>
              <p>आपके पास मौजूदा प्रोडक्ट का बार कोड स्कैन करें। फिर स्कैन्ड प्रोडक्ट्स की लिस्ट से प्रोडक्ट को कैटेलॉग मैं ऐड करें।</p>
              <div class="btn-block">
                <span class="button">स्कैन करे </span>
              </div>
            </div>
          </router-link>

          <router-link class="product-tab" tag="div" :to="{ path: '/add-product?&shopid=' + $route.query.shopid  }" v-if="$route.query.shopid">
            <div class="prdt-icon">
              <AddProductIcon />
            </div>
            <div class="prdt-info">
              <h2>नया प्रोडक्ट जोड़ें</h2>
              <p>फॉर्म मैं अपने प्रोडक्ट्स के सभी डिटेल्स बहोत ध्यान से भरें जैसे नाम, प्रोडक्ट के बारे मैं, प्राइस, आदि और सबमिट करके अपने प्रोडक्ट को कैटेलॉग मैं जोड़ें।</p>
              <div class="btn-block">
                <span class="button">प्रोडक्ट जोड़ें </span>
              </div>
            </div>
          </router-link>
          <router-link class="product-tab" tag="div" :to="{ path: '/add-product'}" v-else>
            <div class="prdt-icon">
              <AddProductIcon />
            </div>
            <div class="prdt-info">
              <h2>नया प्रोडक्ट जोड़ें</h2>
              <p>फॉर्म मैं अपने प्रोडक्ट्स के सभी डिटेल्स बहोत ध्यान से भरें जैसे नाम, प्रोडक्ट के बारे मैं, प्राइस, आदि और सबमिट करके अपने प्रोडक्ट को कैटेलॉग मैं जोड़ें।</p>
              <div class="btn-block">
                <span class="button">प्रोडक्ट जोड़ें </span>
              </div>
            </div>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import '../assets/css/add-product-option.scss';
import ArrowLeftBackIcon from '@/components/Icons/ArrowLeftBackIcon';
import ProductSearchIcon from '@/components/Icons/ProductSearchIcon';
import ProductBarCodeIcon from '@/components/Icons/ProductBarCodeIcon';
import AddProductIcon from '@/components/Icons/AddProductIcon';

export default {
  name: 'AndroidAddProductRoute',
//   props: {
//     openAddProductOptionModal: Boolean,
//     isProductListLength: Boolean
//   },
  data() {
    return {
        openAddProductOptionModal: true
    };
  },
  components: {
    ArrowLeftBackIcon,
    ProductSearchIcon,
    ProductBarCodeIcon,
    AddProductIcon,
  },
  watch: {},
  methods: {
      goBack() {
      if (this.$cookie.get("version-code") > 57) {
        if (window.history.length == 1) {
          try {
            JSBridgePlugin.gotToHome();
          } catch (err) {
            console.log(err);
          }
        } else {
          this.$router.go(-1);
        }
      } else {
        this.$router.go(-1);
      }
    },
  },
  mounted() {},
};
</script>
